export const actionTypes = {
    SET_BROWSER_PROFILE_DATA: 'SET_BROWSER_PROFILE_DATA',
    SET_BROWSER_PROFILE_CANCEL_TOKEN: 'SET_BROWSER_PROFILE_CANCEL_TOKEN',
    IS_BROWSER_PROFILE_FETCHING: 'IS_BROWSER_PROFILE_FETCHING'
}